import { Injectable, Injector, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, forkJoin, Observable, of, switchMap, throwError } from 'rxjs';
//only used in tmv, so we can safely import from 'projects/tmv/src/environments/environment'
import { environment } from 'projects/tmv/src/environments/environment';
import { CsrfService } from './csrf.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Capacitor } from '@capacitor/core';
import { EventSource, EventSourceFetchInit } from 'eventsource'

// ? this service is specific to tmv, should not be located in tt-lib !!! 
@Injectable({
  providedIn: 'root'
})
export class RemarkService {
  baseURL: string = environment.BASEURL + environment.URL_SUFFIX + 'tmv-services/remarks';

  constructor(
    private http: HttpClient,
    private zone: NgZone,
    private injector: Injector,
    //private csrfService: CsrfService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) { }


  /**
   * Sends a remark to NGI about the application
   * TODO: cast message param (avoid 'any')
   * @param message 
   */
  sendAppRemark(message: any, recaptchaToken?: string): Observable<any> {
    const csrfService = this.injector.get(CsrfService);
    const csrf$ = csrfService.fetchToken();
    //if no recaptchaToken, take one
    const recaptcha$ = recaptchaToken ? of(recaptchaToken) : this.recaptchaV3Service.execute('sendAction');
    return forkJoin([csrf$, recaptcha$]).pipe(
      switchMap(([csrfToken, recaptcha]) => {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        if (csrfToken) headers = headers.set('CSRF-Token', csrfToken);
        if (recaptcha) headers = headers.set('x-csrf-token', recaptcha);
        return this.http.post(
          `${this.baseURL}/sendAppRemark`,
          message,
          { headers }
        );
      }),
      catchError(err => {
        console.error('sendAppRemark error', err);
        return throwError(() => err); // bubble up
      })
    );
    // return csrfService.fetchToken().pipe(
    //   switchMap((csrfToken) => {
    //     let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //     if (csrfToken) {
    //       headers = headers.set('CSRF-Token', csrfToken);
    //     }
    //     if (recaptchaToken) {
    //       headers = headers.set('x-csrf-token', recaptchaToken);
    //     }

    //     return this.http.post(
    //       `${this.baseURL}/sendAppRemark`,
    //       message,  
    //       { headers }
    //     );
    //   }),
    //   catchError(err => {
    //     console.error('sendAppRemark error', err);
    //     return throwError(() => err); // bubble up instead of swallowing
    //   })
    // );
  }
  /**
   * Sends a remark to NGI about Cartoweb 
   * TODO: cast message param (avoid 'any')
   * @param message 
   * @param pictures 
   */
  sendCartowebRemark(message: any, pictures?: File[], recaptchaToken?: string): Observable<any> {
    const csrfService = this.injector.get(CsrfService);

    const csrf$ = csrfService.fetchToken();
    const recaptcha$ = recaptchaToken ? of(recaptchaToken) : this.recaptchaV3Service.execute('sendAction');

    return forkJoin([csrf$, recaptcha$]).pipe(
      switchMap(([csrfToken, recaptcha]) => {
        let headers = new HttpHeaders();
        if (csrfToken) headers = headers.set('CSRF-Token', csrfToken);
        if (recaptcha) headers = headers.set('x-csrf-token', recaptcha);

        if (Capacitor.isNativePlatform() && typeof message.url === 'string' && message.url.indexOf('localhost') > -1) {
          if(message.url.indexOf('localhost:') > -1){
            message.url = message.url.replace(/:\d+/, '');
          } 
           message.url = message.url.replace('localhost', 'topomapviewer.ngi.be');
        }

        const formData = new FormData();
        formData.append('data', JSON.stringify(message));
        if (pictures?.length) {
          pictures.forEach(file => formData.append('file', file, file.name));
        }
        return this.http.post(`${this.baseURL}/sendCartowebRemark`, formData, { headers });
      }),
      catchError(err => {
        console.error('sendCartowebRemark error', err);
        return throwError(() => err);
      })
    );

    // return csrfService.fetchToken().pipe(
    //   switchMap((csrfToken) => {

    //     let headers = new HttpHeaders();

    //     if (csrfToken) {
    //       headers = headers.set('CSRF-Token', csrfToken);
    //     }
    //     if (recaptchaToken) {
    //       headers = headers.set('x-csrf-token', recaptchaToken);
    //     }
    //     const formData = new FormData();
    //     formData.append('data', JSON.stringify(message));

    //     if (pictures?.length) {
    //       pictures.forEach((file) => formData.append('file', file, file.name));
    //     }

    //     // Send request
    //     return this.http.post(`${this.baseURL}/sendCartowebRemark`, formData, {
    //       headers,
    //       observe: 'response',  // optional, to get full HttpResponse
    //     });
    //   }),
    //   catchError((err) => {
    //     console.error('sendCartowebRemark error', err);
    //     return throwError(() => err);
    //   })
    // );
  }

  photoUploadProgress() {
    return new Observable(observer => {
      const es = Capacitor.isNativePlatform() ? new EventSource(this.baseURL + "/uploadProgress", {
        fetch: (input, init) =>
          fetch(input, {
            ...init,
            headers: {
              ...init.headers,
              Origin: 'https://topomapviewer.ngi.be',
              Referer: 'https://topomapviewer.ngi.be',
            },
          }),
      }) : new EventSource(this.baseURL + "/uploadProgress");

      es.onmessage = (event => {
        this.zone.run(() => {
          observer.next(event);
        })
      });

      es.onerror = (error => {
        this.zone.run(() => {
          es.close();
        })
      })

    })
  }
}
